import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './auth/config.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

constructor(private http: HttpClient,private configService:ConfigService) {}

  initiatePayment(data: any) {
    return this.http.post<any>(`${this.configService.getApiUrl()}/payment/InitiatePayment`, data);
  }
}
